import { parseDroplinkParam } from './shared.service';

/** A strongly typed version of `parseDroplinkParam` that returns just the value. */
export function getDroplink<T extends string | undefined | null>(
  param?: string,
  defaultValue: T = '' as T
): T {
  return param
    ? ((parseDroplinkParam(param)?.value?.value ?? '') as T) || defaultValue
    : defaultValue;
}

/** Helper function to convert checkbox params to a boolean value. */
export function getCheckbox(param?: string, defaultValue = false): boolean {
  return param ? param === '1' : defaultValue;
}
